import type { DayType } from 'generated/index';

import type { Weekday } from './OpeningHours.types';

export const WEEKDAYS: Weekday[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
];

export const DAY_TYPES: DayType[] = [
  'REGULAR',
  'SCHOOL_HOLIDAY',
  'STUDY_DAY',
  'PUBLIC_HOLIDAY'
];
